export const TYPES = {
  ADD_TASK: 'ADD_TASK',
  ADD_DELIVERER: 'ADD_DELIVERER',
  CHANGE_QUANTITY: 'CHANGE_QUANTITY',
  CHANGE_WEIGHT: 'CHANGE_WEIGHT',
  DELETE_TASK: 'DELETE_TASK'
};